
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/configuracoes",
      function () {
        return require("private-next-pages/configuracoes/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/configuracoes"])
      });
    }
  